<script lang="ts" setup>
import { computed, type PropType } from 'vue';
import { FormElement, useFormElement } from '@common';

const props = defineProps({
  element: {
    type: Object as PropType<FormElement>,
    required: true
  }
});

const { label } = useFormElement(props.element);

const harvestYear = computed(() => props.element.parent?.getChild('yearly')?.getChild('harvestYear')?.value ?? null);
</script>

<template>
  <span
    v-if="harvestYear"
    class="d-block text-h6 font-weight-bold pb-4"
    >{{ label }} - {{ harvestYear }}</span
  >
</template>
